module.exports = __webpack_public_path__ + "static/media/features-split-image-05.b6a82d76.png";